$(function () {
	var swiper1 = new Swiper(".gift-container1", {
		effect: "fade",
		loop: true,
		observer: true,
		observeParents: true,
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: ".gift-pagination1",
			clickable: true,
		},
		navigation: {
			nextEl: ".gift-next1",
			prevEl: ".gift-prev1",
		},
	});

	var swiper2 = new Swiper(".gift-container2", {
		effect: "fade",
		loop: true,
		observer: true,
		observeParents: true,
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: ".gift-pagination2",
			clickable: true,
		},
		navigation: {
			nextEl: ".gift-next2",
			prevEl: ".gift-prev2",
		},
	});

	var swiper3 = new Swiper(".role-container", {
		loop: true,
		effect: "fade",
		observer: true,
		observeParents: true,
		pagination: {
			el: ".role-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				return (
					'<span class="' +
					className +
					'">' +
					'<a class="' +
					"cur" +
					(index + 1) +
					'">' +
					"</a>" +
					"</span>"
				);
			},
		},

		on: {
			init: function () {
				swiperAnimateCache(this); //隐藏动画元素
				this.emit("slideChangeTransitionEnd"); //在初始化时触发一次slideChangeTransitionEnd事件
			},
			slideChangeTransitionEnd: function () {
				swiperAnimate(this); //每个slide切换结束时运行当前slide动画
				this.slides
					.eq(this.activeIndex)
					.find(".ani")
					.removeClass("ani"); //动画只展示一次
			},

			transitionEnd: function () {
				$("audio")
					.not(this)
					.each(function () {
						$(this)[0].pause();
						$(this)[0].currentTime = 0.0;
					});
				$(".swiper-slide-active")
					.find(".role")
					.find(".music")[0]
					.play();
			},
		},
	});

	var swiper4 = new Swiper(".act-container", {
		effect: "fade",
		loop: true,
		observer: true,
		observeParents: true,
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: ".act-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".act-next",
			prevEl: ".act-prev",
		},
	});
});
